export default "__VITE_ASSET__CUMu4_GQ__"